module.exports = __webpack_public_path__ + "static/media/track_status.9657fb15.svg";